import { cn } from "@/lib/utils";

interface SEOPreviewProps {
  title: string;
  description: string;
  slug: string;
  className?: string;
}

export function SEOPreview({
  title,
  description,
  slug,
  className,
}: SEOPreviewProps) {
  const displayTitle = title
    ? `${title.slice(0, 60)}${title.length > 60 ? "..." : ""} | Aceena Blog`
    : "Título do Artigo | Aceena Blog";

  const displayDescription = description
    ? `${description.slice(0, 160)}${description.length > 160 ? "..." : ""}`
    : "Descrição do artigo aparecerá aqui. Use até 160 caracteres para melhor visualização nos resultados de busca.";

  const displayUrl = slug
    ? `aceena.com.br/blog/${slug}`
    : "aceena.com.br/blog/seu-artigo";

  return (
    <div className={cn("space-y-3", className)}>
      <p className="text-sm font-medium text-foreground">
        Preview do Google
      </p>
      <div className="p-4 bg-background rounded-lg border border-border space-y-1">
        {/* URL */}
        <p className="text-xs text-muted-foreground truncate">
          {displayUrl}
        </p>
        {/* Title */}
        <p className="text-base text-primary hover:underline cursor-pointer font-medium leading-tight">
          {displayTitle}
        </p>
        {/* Description */}
        <p className="text-sm text-muted-foreground line-clamp-2">
          {displayDescription}
        </p>
      </div>
    </div>
  );
}
